//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CustomFieldType } from './Enums';

export abstract class CustomFieldValueInputItem extends ItemBase {
    FieldID: string | null = null;
    abstract readonly FieldType: CustomFieldType;

    static readonly ClassName: string = "CustomFieldValueInputItem";
}
